module.exports = "#bio {\n  display: flex; }\n\n@media screen and (max-width: 767px) {\n  #bio {\n    display: flex;\n    padding: 0 !important; } }\n"